export const info = [
  // 1
  {
    title: "Clash",
    event_username: "clash",
    src: "/logos/clash.png",
    tagline: "Clash is based on Competitive Programming!",
    info1: `<p>
    Put your logical acumen and coding expertise to the test as you clash with a round of perplexing MCQs followed by a set of time-bound coding challenges, carefully designed to assess your command over programming in the language of your choice- Python, C or C++. Showcase your technical proficiency as you have a go at competitive coding with plenty to learn and nothing to lose.   <br />
    </p>

    <p>
      <h3>Timings</h3> <br/>
      12-02-2021 , Friday : 10:00am to 7:00pm <br/>
      13-02-2021 , Saturday : 10:00am to 6:00pm <br/>
      14-02-2021 , Sunday : 9:00am to 11:00am
      </p>


    <h5>Registration Fees: </h5>
    <ul>
      <li class='nonMemberPrice'>
        <span>₹60</span>&nbsp; for Non-IEEE members
      </li>
      <li class='guestPrice'>
        <span>₹60</span>
      </li>
      <li class='memberPrice'>
        <span>₹50</span>&nbsp; for IEEE members
      </li>
      <li class='pict'>
        <span>₹0</span>&nbsp; for PICT students
       </li>
    </ul>`,
    info2: `<p>
  
    1) A maximum of 1 participant pursuing under-graduate program at their institution is allowed to participate
    <br />
    2) The participants must keep their college verification in handy as you can be asked to disclose it any point of time. Before the final round, all participants will be asked to verify their identity as an under-graduate student and failure to do so will lead to immediate disqualification.
    <br />
    3)Marking scheme and further rules and regulation while playing Clash will be released during the time of the event itself. 
  
      <br />    
      
  </p>`,
    info3: `<p>
    1)There are two rounds in clash: <br/>
    a)MCQ Round(elimination)<br/>
    b)Coding Round(final)
      <br />
    2)Participants can register via the Credenz app or the website.
      <br />
    3)The event will be divided into two levels, Junior and Senior where the difficulty will vary accordingly. All the levels will test out your knowledge of C/C++ and Python.
    <br/>
    4)The FE and SE participants will be taking on the Junior Category and the TE and BE participants will take on the Senior Category.
    <br/>
    5)The participants clearing out the cut off score in round 1 will be notified for round 2 and will be able to participate in the final round for the prize.

      </p>`,
    info4: `<p>
    1)Judging in round 1 will be based on programming skills, ability to understand code, algorithms and knowledge of the fundamentals of C/C++ and Python.
    <br/>
    2)Judging for round 2 will be based on the time and space efficiency of your code to solve the given challenges in restricted time.
    <br/><br/>
    <strong>Prizes</strong><br/>
    <strong>Junior Section </strong><br/>
    <strong>Winner :<strong/>&nbsp;3000/- <br/>
    <strong>1st Runner Up :</strong>&nbsp;2000/- <br/><br/>
    Senior Section <br/>
    <strong>Winner :</strong>&nbsp;3000/- <br/>
    <strong>1st Runner Up :</strong>&nbsp;2000/- <br/>

    </p>`,
    info5: `   <p className=" text-center">
    Tanmay Pardeshi &nbsp;<br>
    <i className="fa fa-phone fa-icons "></i>
    <a href="tel:+91 99227 04483">
    <span>&nbsp;+91 99227 04483</span>
    </a></p>

    <p className=' text-center'>
      Pranjal Newalkar  &nbsp;
      <br />
      <i className='fa fa-phone fa-icons '></i>
      <a href='tel:+91 95529 50492'>
        <span>&nbsp;+91 95529 50492</span>
      </a>
    </p>`,
  },
  // 2
  {
    title: "Reverse Coding",
    event_username: "rc",
    src: "/logos/rc.png",
    tagline: "Hone your problem-solving skills by decrypting complex questions",
    info1: `<p>
    A coding competition to test your compilation of the combinations of algorithms and conceptual understanding of the programming languages C/C++. Combine logic and agility to decipher given patterns and code to decode these sequences to find the final answer.
    
    <p>
      <h3>Timings</h3> <br/>
      12-02-2021 , Friday : 10:00am to 7:00pm <br/>
      13-02-2021 , Saturday : 10:00am to 6:00pm <br/>
      14-02-2021 , Sunday : 12:00pm to 2:00pm
    </p>
    
    <h5>Registration Fees: </h5>
    <ul>
      <li class='nonMemberPrice'>
        <span>₹60</span>&nbsp;  for Non-IEEE members
      </li>
      <li class='guestPrice'>
        <span>₹60</span>
      </li>
      <li class='memberPrice'>
        <span>₹50</span>&nbsp;  for IEEE members
      </li>
      <li class='pict'>
        <span>₹0</span>&nbsp; for PICT students
       </li>
    </ul>`,
    info2: `<p>
    1)A maximum of 1 participant pursuing under-graduate program at their institution is allowed to participate. 
    <br /> <br />
    2) The participants must keep their college verification in handy as you can be asked to disclose it any point of time. Before the final round, all participants will be asked to verify their identity as an under-graduate student and failure to do so will lead to immediate disqualification.
    <br/><br/>
    3)Marking scheme and further rules and regulation while playing RC will be released during the time of the event itself.
  </p>`,
    info3: `<p>
    1)There are two rounds in RC:<br/>
    a)Logic Round (elimination)<br/>
    b)Decipher and code Round (final)
    <br />
     2)Participants can register via the Credenz app or the website.

  <br />
  3)The event will be divided into two levels, Junior and Senior where the difficulty will vary accordingly. All the levels will test out your knowledge of C/C++ and Python. 
   <br />
   4)The FE and SE participants will be taking on the Junior Category and the TE and BE participants will take on the Senior Category.
  <br />
  5)The participants clearing out the cut off score in round 1 will be notified for round 2 and will be able to participate in the final round for the prize.

</p>`,
    info4: `<p>
      1) Judging in round 1 will be based on the correctness of the decoded mathematical pattern with or without coding.
      <br/>
    2) Judging for round 2 will be based on the time and space efficiency of your code to solve the given challenges in restricted time.
    <br/><br/>
    <strong>Prizes</strong><br/>
    <strong>Junior Section</strong> <br/>
    <strong>Winner :<strong/>&nbsp;3000/- <br/>
    <strong>1st Runner Up :<strong/>&nbsp;2000/- <br/><br/>
    Senior Section <br/>
    <strong>Winner :</strong>&nbsp;3000/- <br/>
    <strong>1st Runner Up :</strong>&nbsp;2000/- <br/>
      </p>`,
    info5: `<p className=" text-center">
    Sanket Landge &nbsp;<br>
    <i className="fa fa-phone fa-icons "></i>
    <a href="tel: +91 70209 83032">
    <span>&nbsp; +91 70209 83032</span>
    </a></p>

      <p className=" text-center">
      Kaustubh Odak &nbsp;<br>
      <i className="fa fa-phone fa-icons "></i>
      <a href="tel:+91 96502 11332">
      <span>&nbsp;+91 96502 11332</span>
      </a></p>`,
  },
  // 3#
  {
    title: "Pixelate",
    event_username: "pixelate",
    src: "/logos/pixelate.png",

    tagline:
      "Let your creativity fuse with thoughtful designs and artistic originality.",
    info1: `<p>
    Get ready to paint virtual canvas with your creative and thoughtful designs! Come, digitalise your art and let your mouse be your brush.
    </p>

    <p>
    <h3>Timings</h3> <br/>
    13-02-2021 , Saturday : 2:30pm to 5:15pm <br/>
    </p>

    <h5>Registration Fees: </h5>
    <ul>
      <li class='nonMemberPrice'>
        <span>₹50</span>&nbsp;  for Non-IEEE members
      </li>
      <li class='guestPrice'>
        <span>₹50</span>
      </li>
      <li class='memberPrice'>
        <span>₹40</span>&nbsp;  for IEEE members
      </li>
      <li class='pict'>
        <span>₹0</span>&nbsp; for PICT students
       </li>
    </ul>`,
    info2:
      //ye last year ka que he iss saal ka badalna hoga
      `<p>
    1)Candidate pursuing undergraduate course at any institute is allowed to participate. 
    <br/>
    2)Participants can register online on the official Credenz website.
    <br/>
    3)Each participant should have their own laptop and internet connection facility.
    <br/>
  </p>`,
    info3: `<p>
    1)The topic will be given on the date of the event with detailed instructions in a google form.
    <br />
  2) The link will be sent to each participant through their registered email Id.
  <br />
  3) The  time allotted to complete the task will be 2 hours.
  <br />
  4) The design should be submitted in *psd, *cdr, *ai etc format.
  <br />
  5)The design submitted should not be flattened.
  <br/>
  6)The brushes and fonts used should be mentioned in the documentation.
  <br/>
  7)Any external source or images used should also be included in the documentation.
  
</p>`,
    info4: `<p>  
    <ul>
      <li>1) Creativity and originality of the design.</li>
      <li>2) Distinct features incorporated in the design.</li>
      <li>3) Persuasiveness of the design, i.e. the efficiency of the design to convey the required message.</li>
      <li>4) Photoshop skills.</li>
      <li>5) Layering and masking.</li>
      <li>6) The decision of the judges will be final and shall be respected.</li>
    <ul/>
    <br/><br/>
    <strong>Prizes</strong><br/>
    <strong>Winner :<strong/>&nbsp;2000/- <br/>
    </p>`,
    info5: `<p className=' text-center'>
      Shreya Deshpande &nbsp;
      <br />
      <i className='fa fa-phone fa-icons '></i>
      <a href='tel:+91 7588404218'>
        <span>&nbsp; +91 7588404218</span>
      </a>
    </p>`,
  },
  //4#
  {
    title: "Cretronix",
    event_username: "cretronix",
    src: "/logos/cretronix.png",

    tagline: "Build and exhibit your own circuits by solving tech problems.",
    info1: `<p>
    Battle it out on the breadboard!
    <br />
    Challenge your brains to clear a test where you demonstrate your knowledge in the field of electronics, physics, logical ability and build a circuit by interpreting the hints provided.
    <br />
    Prerequisites: Theoretical and practical knowledge in the field of digital electronics, electrical circuits and physics.
    </p>

    <p>
      <h3>Timings</h3> <br/>
      12-02-2021 , Friday : 10:00am to 7:00pm <br/>
      14-02-2021 , Sunday : 10:00am to 12:00pm
    </p>

    <h5>Registration Fees: </h5>
    <ul>
      <li class='nonMemberPrice'>
        <span>₹50</span>&nbsp;  for Non-IEEE members
      </li>
      <li class='guestPrice'>
        <span>₹50</span>
      </li>
      <li class='memberPrice'>
        <span>₹40</span>&nbsp;  for IEEE members
      </li>
      <li class='pict'>
        <span>₹0</span>&nbsp; for PICT students
       </li>
    </ul>`,
    info2: `<p>
    1) ) Participant can participate individually.
    <br /> <br />
    2) Participants will be provided with credentials to join tinkercad for the 2nd round.
    <br /><br />
    3) Participants can use datasheets for the components they are using and are supposed to provide a link of the same.
    </p>`,
    info3: `<p>
    (Junior and Senior):
  <br />
  1) 1st round:It will consist of Multiple Choice Questions (MCQs) from different
   categories. There will be 30 questions for a time limit of 30 minutes.
  <br />
  2) 2nd round:The participants will be given a problem statement and they are supposed to
    implement the solution with the help of tinkercad simulation environment.
    <br /> 
    LINK: <a href="https://www.tinkercad.com/dashboard">https://www.tinkercad.com/dashboard</a>
    
</p>`,
    info4: `<p> Round 1:<br /> Each question carries a single mark. No negative marking. Teams having score above  
    the score threshold will be selected for Round 2. <br />
    Round 2: <br /> Top two teams earning maximum credits based on the understanding of the problem statement, 
    component selection, practical performance and explanation of the implemented circuit will be declared as winners. 
    <br />
     Winner and runner-up will be awarded.<br /><br/>
     <strong>Prizes</strong><br/>
     <strong>Winner :<strong/>&nbsp;2000/- <br/>
     <strong>1st Runner Up :<strong/>&nbsp;1000/- <br/>
    </p>`,
    info5: `<p className=' text-center'>
    Ajay Kompalwad &nbsp;
      <br />
      <i className='fa fa-phone fa-icons '></i>
      <a href='tel:+91 8668460490'>
        <span>&nbsp; +91 8668460490</span>
      </a>
    </p>
    <p className=' text-center'>
    Akshay Satpute &nbsp;
      <br />
      <i className='fa fa-phone fa-icons '></i>
      <a href='tel:+91 7057602590'>
        <span>&nbsp;+91 7057602590</span>
      </a>
    </p>`,
  },
  //5#
  {
    title: "Bplan",
    event_username: "bplan",
    src: "/logos/bplan.png",

    tagline:
      "Showcase your entrepreneurial skills by presenting innovative business plans to the world",
    info1: `<p>
    Ever dreamt of having your own business or a product? B-Plan is the perfect 
    platform for you! A perfect presentation describing your business idea will 
    help you grab a chance to win funding from the investors. So showcase your 
    ideas before a panel of best marketing professionals. 
    </p>

    <p>
      <h3>Timings</h3> <br/>
      14-02-2021 , Sunday : 10:30am to 4:00pm
    </p>

    <h5>Registration Fees: </h5>
    <ul>
      <li class='nonMemberPrice'>
        <span>₹120</span> &nbsp;for Non-IEEE members
      </li>
      <li class='guestPrice'>
        <span>₹120</span>
      </li>
      <li class='memberPrice'>
        <span>₹100</span> &nbsp;for IEEE members
      </li>
      <li class='pict'>
        <span>₹0</span>&nbsp; for PICT students
       </li>
    </ul>`,
    info2: `<p>
    1) A maximum of three candidates per plan pursuing undergraduate/graduate/postgraduate 
    program at their institution will be allowed per team.
    <br /> <br />
    2) Proposed business plan should not be in violation of any intellectual property rights.
    <br/><br/>
    3) Proposed business plan should be submitted by 10th February 2021
  </p>`,
    info3: `<p>
    1) At stage 1, the soft copy of the abstract (summary) should be submitted to pisb.bplan21@gmail.com by 10th February 2021.
  <br />
  2) The Soft copy should be a .pdf file.
  <br />
  3)The top 7 teams will compete in the next stage.
    <br />
    4) Each team will be given 12 minutes in the final round to present their B-PLAN in front of a 
    panel of judges and audience. A warning bell will be given at 10 minutes and a final 2 minutes thereafter. 
      <br />
   5) The presentation would be followed by a question-answer session where they would be questioned on different hurdles, opportunities and obstacles at various points.
     <br />
     6) The main stress during question-answer session would be given on feasibility and Exit Plan.
</p>`,
    info4: `<p> <ul className="">
      <li>1) Innovation involved in the development of the idea and its practicality.</li>
      <li>2) Originality and Patentability.</li>
      <li>3) Technical feasibility.</li>
      <li>4) Implementation of the product.</li>
      <li>5) Cost efficiency (if relevant).</li>
      <li>6) Superiority of the product over existing products in market.</li>
      <li>7) Participants will be judged on the basis of their business acumen and on how sustainable and innovative their solution is.</li>
      <li>8) The decision of the judges will be final and shall be respected.</li>
    </ul>
    <br/><br/>
    <strong>Prizes</strong><br/>
    <strong>Winner :<strong/>&nbsp;3000/- <br/>
    <strong>1st Runner Up :<strong/>&nbsp;2000/- <br/>
  .</p>`,
    info5: `<p className=' text-center'>
    Janhavi Bagul &nbsp;
      <br />
      <i className='fa fa-phone fa-icons '></i>
      <a href='tel:+91 9970004781'>
        <span>&nbsp; +91 9970004781</span>
      </a>
    </p>
    <p className=' text-center'>
    Manasi Thonte &nbsp;
      <br />
      <i className='fa fa-phone fa-icons '></i>
      <a href='tel+91 9561118320'>
        <span>&nbsp; +91 9561118320</span>
      </a>
    </p>
    <p className=' text-center'>
    Sampreeti Saha &nbsp;
      <br />
      <i className='fa fa-phone fa-icons '></i>
      <a href='tel:+91 9168743366'>
        <span>&nbsp;+91 9168743366</span>
      </a>
    </p>`,
  },
  //6#
  {
    title: "Wallstreet",
    event_username: "wallstreet",
    src: "/logos/wallstreet.png",

    tagline:
      "Get an insight on stock markets by Investing and trading virtual money",
    info1: `<p>
    Let the rise and fall of market shares bring out your inner businessman! Get an insight in the field of Investment banking, corporate financing and trading to take over the virtual stock market. After all, every investment is one step closer to your dream bank balance!
        </p>
    <h5>Registration Fees: </h5>
    <ul>
      <li class='nonMemberPrice'>
        <span>₹50</span>&nbsp;  for Non-IEEE members
      </li>
      <li class='guestPrice'>
        <span>₹50</span>
      </li>
      <li class='memberPrice'>
        <span>₹40</span>&nbsp;  for IEEE members
      </li>
      <li class='pict'>
        <span>₹0</span>&nbsp; for PICT students
       </li>
    </ul>`,
    info2: `<p>
    1) Every Participating candidate should be pursuing Undergraduate/Graduate courses.
    <br /> <br />
    2) Participants should have their own college ID cards.
    </p>`,
    info3: `<p>
    1) Every participant will be given virtual money to trade on our virtual stock market.
          <br />
    2) The event will be conducted on our Android App/Website.
      <br />
    3) Mock NEWS will be flashed regarding listed companies and their sectors based on which participants will buy/sell stocks to ultimately become the biggest gainer.
      <br />
   
  </p>`,
    info4: `<p>Top 2 participants with Highest Capital at the end of Day 3 will be declared as winners.
    <br/>
    <strong>Prizes</strong><br/>
    <strong>Winner :</strong>&nbsp;3000/- <br/>
    <strong>1st Runner Up :</strong>&nbsp;2000/- <br/>
    </p>`,
    info5: `<p className=' text-center'>
    Muffadal Diwan &nbsp;
      <br />
      <i className='fa fa-phone fa-icons '></i>
      <a href='tel:+91 7073152539'>
        <span>&nbsp; +91 7073152539</span>
      </a>
    </p>
    <p className=' text-center'>
    Krishiv Mewani &nbsp;
      <br />
      <i className='fa fa-phone fa-icons '></i>
      <a href='tel:+91 9158087902'>
        <span>&nbsp;+91 9158087902</span>
      </a>
    </p>`,
  },
  //7#
  {
    title: "Datawiz",
    event_username: "datawiz",
    src: "/logos/datawiz.png",

    tagline:
      "Test your Machine learning and data analytics skills before stepping into the world of Data Science..",
    info1: `<p>
    Get ready to set off on a journey to the world of data science. DataWiz gives you an opportunity to test your machine learning and data analytics skills, work on datasets to analyse and make predictions using your models.
    <br/>
   Datawiz is a week-long machine learning competition hosted on Kaggle. The participants can form teams of up to 3 members and submit their predicted data values. The team with the highest accuracy on the leaderboard at the end of the week will be declared as winners.
   </p>

   <p>
   <h3>Timings</h3> <br/>
   Round 1: 12th - 16th February 2021 <br/>
   Round 2: 17th - 20th February 2021
   </p>
  

   <h5>Registration Fees: </h5>
   <ul>
     <li class='nonMemberPrice'>
       <span>₹60</span>&nbsp;  for Non-IEEE members
     </li>
     <li class='guestPrice'>
       <span>₹60</span>
     </li>
     <li class='memberPrice'>
       <span>₹50</span>&nbsp;  for IEEE members
     </li>
     <li class='pict'>
        <span>₹0</span>&nbsp; for PICT students
       </li>
    </ul>`,
    info2: `<p>
    1)Each team of students may consist of a maximum of 3 participants.
    <br /> <br />
    2)One account per participant
    <br /> <br />
    3)Signing In on Kaggle through Multiple accounts is prohibited.
<br /> <br />
    4)No private sharing outside teams.
<br /> <br />
    5)Privately sharing code or data outside of teams is not permitted.
<br /> <br />
    6)Results should be reproducible to be eligible for prizes.
  </p>`,
    info3: `<p>
    Team Mergers: <br />
    Team mergers are allowed in this competition.
    <br /><br/>
    Team Limits: <br />
    A team may consist of a maximum of 3 participants.
    </p>`,
    info4: `<p>
    Submission Limits <br />
    You may submit a maximum of 10 entries per day. <br />
    You may select up to 2 final submissions for judging.<br/>
    <br/>
    <strong>Prizes</strong><br/>
    <strong>Winner :</strong>&nbsp;2000/-<br/>
    <strong>1st Runner Up :</strong>&nbsp;1000/-<br/>
    </p>`,
    info5: `<p className=' text-center'>
      Aboli Marathe &nbsp;
      <br />
      <i className='fa fa-phone fa-icons '></i>
      <a href='tel:+91 9545413291'>
        <span>&nbsp; +91 9545413291 </span>
      </a>
    </p>
    <p className=' text-center'>
     Ayush Das &nbsp;
      <br />
      <i className='fa fa-phone fa-icons '></i>
      <a href='tel:+91 9373236438'>
        <span>&nbsp;+91 9373236438</span>
      </a>
    </p>`,
  },
  //8#
  {
    title: "Enigma",
    event_username: "enigma",
    src: "/logos/enigma.png",

    tagline:
      "Get ready to push your aptitude, logical reasoning skills limits by solving mind-boggling questions.",
    info1: `<p>
    Are you diligent enough to face the mind-boggling questions which will push your logical 
    reasoning to its limits? Then do not miss this amazing opportunity. </br>
    Enigma is a logical reasoning based questionnaire, which will test your aptitude, thinking capability, response time and mental ability.
    Get ready to put your Grey Cells to work!
    
       </p>

    <p>
      <h3>Timings</h3> <br/>
      12-02-2021, Friday : 10:00 am to 7:00pm <br/>
      13-02-2021, Saturday : 10:00am to 6:00pm <br/>
      14-02-2021 , Sunday : 2:00pm to 5:00pm <br/> 
    </p>


    <h5>Registration Fees: </h5>
    <ul>
      <li class='nonMemberPrice'>
        <span>₹50</span>&nbsp;  for Non-IEEE members
      </li>
      <li class='guestPrice'>
        <span>₹50</span>
      </li>
      <li class='memberPrice'>
        <span>₹40</span>&nbsp;  for IEEE members
      </li>
      <li class='pict'>
        <span>₹0</span>&nbsp; for PICT students
       </li>
    </ul>`,
    info2: `<p>
    1) Candidates pursuing an Undergraduate/graduate program at their institution will be allowed to participate. It will be an individual event.
    <br /> <br />
    2)All the participants should follow all the instructions as mentioned in the mail received after registration.
    </p>`,
    info3: `<p>
   1) There will be two rounds.
   <br/>
5)ROUND 1: <br />
  &nbsp;&nbsp;&nbsp;a.There will be 35 questions in this round.  <br />
  &nbsp;&nbsp;&nbsp;b.Time limit is 40 minutes.<br />
  &nbsp;&nbsp;&nbsp;c.For every right answer, you will be awarded points and no negative points for a wrong answer.
<br />
&nbsp;&nbsp;&nbsp;d.The marking scheme will be told on the day of the event. <br />
6)ROUND 2:<br />
&nbsp;&nbsp;&nbsp;a.There will be 5 Puzzles and 5 MCQs in this round.<br />
&nbsp;&nbsp;&nbsp;b.Time Limit is 2 hours<br />
&nbsp;&nbsp;&nbsp;c.You must claim whenever you are done. Earliest claim with max. score wins.

</p>`,

    info4: `<p>
    1)There will be two rounds. 
    <br/>
    2)You need to qualify the threshold score to get into the next round. The threshold will be decided based upon the performance of all the teams.
    <br/>
    3)The decision of the organizer will be final.
    <br />
    4)There is no negative marking at any stage.
    <br/><br/>
    <strong>Prizes</strong><br/>
    <strong>Winner :<strong/>&nbsp;3000/- <br/>
    <strong>1st Runner Up :<strong/>&nbsp;2000/- <br/>
    </p>`,

    info5: `<p className=' text-center'>

    Saket Gupta &nbsp;
    <br />
    <i className='fa fa-phone fa-icons '></i>
    <a href='tel:+91 77200 79968'>
      <span>&nbsp; +91 77200 79968 </span>
    </a>
  </p>
  <p className=' text-center'>
   Atharva Sadre &nbsp;
    <br />
    <i className='fa fa-phone fa-icons '></i>
    <a href='tel:+91 75882 46742'>
      <span>&nbsp;+91 75882 46742</span>
    </a>
  </p>`,
  },
  //9#
  {
    title: "Quiz",
    event_username: "quizz",
    src: "/logos/quiz.png",

    tagline:
      "Test your knowledge across wide range of topics and get a chance to win some exciting prizes.",
    info1: `<p>
    Brainstorm on the questions ranging from Greek mythology to world politics, from 
    Shakespeare to business gurus. Set out on a voyage through mind-boggling questions
     captained by a witty quiz master. Flex your IQ in a set of three quizzes,
      designed to be a battle of wits. <br />

      <p>
      <h3>General Quiz</h3>
      <h3>Timings</h3> <br/>    
      13-02-2021 , Saturday : <br/> 
      Round 1:  12:00 noon to 12:30 pm <br/>
      Round 2: 1:30pm to 3:00 pm 
    </p>

    <p>
      <h3>BizTech Quiz</h3>
      <h3>Timings</h3> <br/>
      12-02-2021 , Friday : <br/> 
      Round 1:  4:30pm to 5:00 pm <br/>
      Round 2: 5:30pm to 7:00 pm 
   </p>

   <p>
    <h3>MELA Quiz</h3>
    <h3>Timings</h3> <br/>
    14-02-2021 , Sunday : <br/> 
    Round 1:  11:30am to 12:00 pm <br/>
    Round 2: 1:00pm to 2:30 pm 
  </p>

    <h5>Registration Fees: </h5>
    <ul>
      <li class='nonMemberPrice'>
        <span>₹50</span>&nbsp;  for Non-IEEE members
      </li>
      <li class='guestPrice'>
        <span>₹50</span>
      </li>
      <li class='memberPrice'>
        <span>₹40</span>&nbsp;  for IEEE members
      </li>
      <li class='pict'>
        <span>₹0</span>&nbsp; for PICT students
       </li>
    </ul>`,
    info2: `<p>
    1.General Quiz: It includes everything from robotics to politics. Test your GK!
       <br /> <br />
    2.MELA Quiz: Movies Entertainment Literature and Arts (MELA) is all set to test your knowledge of literature, arts and entertainment. If you are an entertainment lover, this is for you! 
      <br /><br />
    3.BizTech Quiz: If you are passionate about marketing, economics and Business, then BizTech is the ultimate questionnaire you need to answer.
    <br /><br />
      </p>`,
    info3: `<p>
    1)Candidate pursuing an undergraduate program at any institute is allowed to participate. Participants are encouraged to maintain a copy of their ID card.
    <br/>
    2)Participants can register online on the official Credenz website.
    <br/>
    3)Each team will have a maximum of one participant.
    <br />
    4)Marking scheme and other rules will be announced on the day of the event itself.
  
</p>`,
    info4: `<p>The winner will be selected on the basis of the maximum points scored in final round and/or on the exclusive discretion of the quiz master.
    <br/><br/>
    <strong>Prizes</strong><br/>
    <strong>1)General Quiz </strong><br/>
    <strong>Winner :<strong/>&nbsp;2000/- <br/><br/>
    2)MELA Quiz <br/>
    <strong>Winner :<strong/>&nbsp;2000/- <br/><br/>
    3)BizTech Quiz<br/>
    <strong>Winner :<strong/>&nbsp;2000/- <br/>
    </p>`,
    info5: `<p className=' text-center'>
    Aparna Ranade &nbsp;
      <br />
      <i className='fa fa-phone fa-icons '></i>
      <a href='tel:+91 8149841027'>
        <span>&nbsp; +91 8149841027</span>
      </a>
    </p>
    <p className=' text-center'>
    Asawari Walkade &nbsp;
      <br />
      <i className='fa fa-phone fa-icons '></i>
      <a href='tel:+91 8956783613'>
        <span>&nbsp;+91 8956783613</span>
      </a>
    </p>`,
  },
  //10#
  {
    title: "Webweaver",
    event_username: "webweaver",
    src: "/logos/web.png",

    tagline:
      "Build an aesthetic website to showcase your web development skills",
    info1: `<p>
    An aesthetically pleasing and user-friendly website is necessary to keep visitors engaged online. If you think you have the flair to create such a site, WebWeaver is the competition for you! A perfect integration of technology and creativity will lead you to win this competition.
     <br />
    </p>

    <p>
    <h3>Timings</h3> <br/>
    14-02-2021 , Sunday : 1:00pm to 4:00pm
    </p>


    <h5>Registration Fees: </h5>
    <ul>
      <li class='nonMemberPrice'>
        <span >₹60</span>&nbsp;  for Non-IEEE members
      </li>
      <li class='guestPrice'>
        <span >₹60</span>
      </li>
      <li class='memberPrice'>
        <span>₹50</span>&nbsp;  for IEEE members
      </li>
      <li class='pict'>
        <span>₹0</span>&nbsp; for PICT students
       </li>
    </ul>`,
    info2: `<p>
    1) A team of maximum 2 is permissible for the event.
    <br /> <br />
    2) Use of any front end framework is permitted.
    <br /> <br />
    3) You are allowed to use any language but readymade template must not be used.</li>
    <br /> <br />
    4) Wordpress is not allowed.
    <br /> <br />
  </p>`,
    info3: `<p>
    1st ROUND: <br />
    The problem statement for this year is Fictional universe. Fiction fanatics flaunt your development skills, creating a website on your favourite series anime, movies, books!
    <br/><br/>
    2nd ROUND:<br/>
    The second round shall be conducted during Credenz Live.<br/>
    Approximately 10 teams shall be shortlisted.<br/>
    The teams shall be given certain add-ons over the pages designed earlier.<br/>
    Five add-ons shall be given, specific to the pages designed by the participants.<br/>
</p>`,
    info4: `<p>
    Participants can participate either individually or in a group of 2 and develop a website which is supposed to be submitted 1-2 days before the start of Credenz. On the first day of Credenz, the best website teams are promoted to the second round where people are informed by us to add specific changes to their website. The website with the most aesthetic changes and best compatibility will be announced as the winner.
    <br/><br/>
    <strong>Prizes</strong><br/>
    <strong>Winner :<strong/>&nbsp;2000/- <br/>
</p>`,
    info5: `<p className=' text-center'>
      Yash Sonar &nbsp;
      <br />
      <i className='fa fa-phone fa-icons '></i>
      <a href='tel:+91 97631 26056'>
        <span>&nbsp; +91 97631 26056</span>
      </a>
    </p>
    <p className=' text-center'>
      Elika Mishra &nbsp;
      <br />
      <i className='fa fa-phone fa-icons '></i>
      <a href='tel:+91 96736 42654'>
        <span>&nbsp;+91 96736 42654</span>
      </a>
    </p>`,
  },
  //11#
  {
    title: "Paper Presentation",
    event_username: "paperpresentation",
    src: "/logos/paper.png",

    tagline:
      "Present technical research papers with advanced perspectives while honing your skills of research.",
    info1: `<p>
    An investment in knowledge always pays the best interest.
    <br/>
    Compete against the most intellectual minds and their progressive ideas!
    <br />
    Paper presentation is the perfect platform for undergraduate/postgraduate students to present technical papers with advanced perspectives while honing their skills of research and creating new dimensions of technology!
    </p>

    <p>
    <h3>Timings</h3> <br/>
    14-02-2021 , Sunday : 1:00pm to 3:30pm
    </p>
   
    <h5>Registration Fees: </h5>
    <ul>
      <li class='nonMemberPrice'>
        <span>₹150</span>&nbsp;  for Non-IEEE members
      </li>
      <li class='guestPrice'>
        <span>₹150</span>
      </li>
      <li class='memberPrice'>
        <span >₹120</span>&nbsp;  for IEEE members
      </li>
      <li class='pict'>
        <span>₹0</span>&nbsp; for PICT students
       </li>
    </ul>`,
    info2: `<p>
    1.A team of maximum three candidates pursuing undergraduate/postgraduate program is allowed. <br/>
    2.Marking Scheme will be declared on the spot. <br/>
    3.Research Papers sent after 11th February, 2021 11:59 PM won’t be accepted.
    <br /> 
  </p>`,
    info3: `<p>
    1) Only soft copy i.e. a .pdf file, of the paper and abstract should be submitted. The paper should not exceed more than 6 pages.
      <br />
    2) Soft copy of the technical paper and the abstract should be mailed to paper.pisbcredenz@gmail.com.
    <br />
    3) The paper must strictly adhere to the IEEE format.
      <br />
    4) Authors will get 15 minutes to deliver a presentation on their topic followed by a question - answer session.
        <br />
    5) The presentation should be in power point format (.ppt or .pptx).
</p>`,
    info4: `<p> 
    <ul>
        <li>1) Oratory and Presentation skills will be of prime importance.</li>
        <li>2) Relevance of the content in context with the chosen topic.</li>
        <li>3) Judge's decision will be final and binding on all.</li>
    </ul>
    <br/><br/>
    <strong>Prizes</strong><br/>
    <strong>Winner :<strong/>&nbsp;2500/- <br/>
    <strong>1st Runner Up :<strong/>&nbsp;1500/- <br/>
</p>`,
    info5: `<p className=' text-center'>
    Anushka Mali &nbsp;
      <br />
      <i className='fa fa-phone fa-icons '></i>
      <a href='tel:+91 7385747678'>
        <span>&nbsp; +91 7385747678</span>
      </a>
    </p>`,
  },
  //12#
  {
    title: "Network Treasure Hunt",
    event_username: "nthh",
    src: "/logos/nth.png",

    tagline:
      "Decrypt the clues to solve complex puzzles and race your way to finish at top.",
    info1: `<p>
    Network Treasure Hunt is an online treasure hunt where participants follow a trail of clues, surfing a range of websites to decipher the puzzles. 
    <br/>
    Tread carefully along your way, solving a series of strategic clues, watching out for the concealed misdirection. 
    <br/>
    Decrypt the clues, enjoy the hunt and race your way to the finish to win some exciting goodies! 
    <br/>
    This is your chance to put your logic and reasoning to test. So, log on to our website and be a Sherlock for a day!
    </p>
    <h5>Registration Fees: </h5>
    <ul>
      <li>
       <strong>Free</strong>
      </li>
    </ul>`,
    info2: `<p>
    1)Register to get your NTH username and password.
    <br/>
    2)Open NTH website: http://www.nth.credenz.in/ 
    <br/>
    3)Login using the credentials sent on the mail.
    <br/>
    4)You will be directed to the starting page of the hunt.<br/>
    5)To advance, crack the question, and put the answer in the URL: <br/>
    FROM <br/>
    http://www.nth.credenz.in/question.php <br/>
    TO <br/>
    http://www.nth.credenz.in/answer.php
    <br/>    
    6)You need to use Google for many of them to solve. Of course, that is where you search for everything you don't know.
    <br/>
    7)Check the source of the pages, you'll get some important clues for hunting further. The titles may also give you clues.
    <br/>
    Most importantly, do not forget to have fun!

  </p>`,
    info3: `<p>
    1) NTH will be conducted twice during Credenz. Both the Treasure Hunt are conducted independently 
    and will have a separate list of winners.      
     <br />
     2)The first hunt is to get the participants acquainted with the format of the online hunt and also with the wide variety of riddles and puzzles that they could come across in the main hunt. 
     <br />
    3) The second hunt, also the main "Network Treasure Hunt" has much higher stakes with some amazing prizes. This hunt will be longer than the previous hunt and will test the limits of the participants. 
      <br />
      4) The hunt is designed to be very intriguing and super fun to play.
   </p>`,
    info4: `<p>
    An online dynamic leaderboard is maintained throughout the hunt. The leaderboard shows the level and rank of the participants. 
    <br /><br/>
    NOTE: In case of a tie, the participant who cleared the level faster will acquire the top spot.
    <br/><br/>
    <strong>Prizes</strong><br/>
    <strong>Winner :<strong/>&nbsp;2500/- <br/>
    <strong>1st Runner Up :<strong/>&nbsp;1500/- <br/>
    <strong>2nd Runner Up :<strong/>&nbsp;1000/- <br/>
    </p>`,
    info5: `<p className=' text-center'>
    Garvita Jain &nbsp;
      <br />
      <i className='fa fa-phone fa-icons '></i>
      <a href='tel:+91 89895 53238'>
        <span>&nbsp; +91 89895 53238</span>
      </a>
    </p>
    <p className=' text-center'>
    Prajwal Patankar &nbsp;
      <br />
      <i className='fa fa-phone fa-icons '></i>
      <a href='tel:+91 88887 26344'>
        <span>&nbsp;+91 88887 26344</span>
      </a>
    </p>`,
  },
];
